import { useDispatch } from 'react-redux'
import { trackInternalEvent } from '@rio/tracking'

import { useUser } from 'builder/hooks/useUser'
import { useFeaturesConfig } from 'builder/hooks/featureConfig/useFeaturesConfig'
import { actions } from 'builder/modules/panel'
import { actions as userActions } from 'builder/modules/user'

type ReturnType = {
  isBannerVisible: boolean
  isButtonVisible: boolean
  closeBanner: () => void
  handleResumeWritingPromo: () => void
  handleResumeWritingButton: () => void
}

export const useResumeWriting = (): ReturnType => {
  const user = useUser()
  const dispatch = useDispatch()
  const { features } = useFeaturesConfig()

  const isBannerVisible = !!features?.rbRw && !user?.uiStates?.rwPromoSeen
  const isButtonVisible = !!(features?.rbRw && user?.uiStates?.rwPromoSeen)

  const updateUIStates = () => {
    dispatch(actions.setUIStatesConfigStatus({ rw_promo_seen: true }))
    dispatch(userActions.setUIUserState({ rwPromoSeen: true }))
  }

  const getActionLink = () => {
    const params: { [key: string]: string } = {
      dt: 'super35',
      pt: 'UWYxd6Xe2VTS0',
      utm_content: 'get_expert_help',
    }

    if (features?.superApp) {
      params.utm_source = 'cio'
      params.utm_medium = 'ciobuilder'
      params.utm_campaign = 'tr_promo_in_ciobuilder'
    }

    if (features?.international) {
      params.utm_source = 'resumeio'
      params.utm_medium = 'riobuilder'
      params.utm_campaign = 'tr_promo_in_riobuilder'
    }

    const queryParams = new URLSearchParams(params)

    return `https://topresume.com/resume-writing?${queryParams.toString()}`
  }

  const closeBanner = () => {
    trackInternalEvent('click_rw_promo', { button: 'next' })
    updateUIStates()
  }

  const handleResumeWritingPromo = () => {
    trackInternalEvent('click_rw_promo', { button: 'get_expert_help' })
    updateUIStates()
    window.open(getActionLink(), '_blank')
  }

  const handleResumeWritingButton = () => {
    trackInternalEvent('click_get_expert_help', { label: 'builder' })
    window.open(getActionLink(), '_blank')
  }

  return {
    isBannerVisible,
    isButtonVisible,
    closeBanner,
    handleResumeWritingPromo,
    handleResumeWritingButton,
  }
}
